import type { TActivity, TSession, TSessionStats, TUser, TUserSession } from "@/types"
import { api } from "./api"
import type { IAPIParams } from "./types"
import { generateAPIResource } from "./utils"

// Activities and Sessions APIs
export const activitiesAPI = {
  ...generateAPIResource<TActivity>("/activities"),
  copy: (id: string) => api.post<TActivity>(`/activities/${id}/copy`).then((res) => res.data),
}

export const sessionsAPI = {
  ...generateAPIResource<TSession>("/sessions"),
  population: (id: string) => api.get<TUser[]>(`/sessions/${id}/population`).then((res) => res.data),
  neighbours: (id: string) => api.get<TSession[]>(`/sessions/${id}/neighbours`).then((res) => res.data),
  stats: (params: IAPIParams<"id">) => api.get<TSessionStats[]>(`/sessions/stats`, { params }).then((res) => res.data),
}

export const usersessionAPI = {
  ...generateAPIResource<TUserSession>("/user_sessions"),
  start: (data: Pick<TUserSession, "id" | "is_anonymous">) =>
    api.post<TUserSession>(`/user_sessions/${data.id}/start`, data).then((res) => res.data),
  finish: (id: string) => api.post<TUserSession>(`/user_sessions/${id}/finish`).then((res) => res.data),
}

export async function fetchAPISessionUserPeers(id: string) {
  const res = await api.get(`/survey/session/${id}/peers`)
  return res.data as TUser[]
}
